import { ColorStyle } from '@/utilities/color-style-map'
import classNames from 'classnames'
import { useEffect, useState } from 'preact/hooks'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import ShoppingCartIcon from './ShoppingCartIcon'

export type SocialProofProps = {
  colorStyle?: Pick<ColorStyle, 'backgroundOpacity12'>
  messages: AsyncIterable<string>
  /** Unique id for the component to persist message state across unmount/mount */
  keepAlive?: boolean
}

let keepAliveMessage = ''

export default function SocialProof({ colorStyle, messages, keepAlive = false }: SocialProofProps) {
  const [message, setMessage] = useState(keepAlive ? keepAliveMessage : '')
  const background =
    colorStyle?.backgroundOpacity12 ?? 'bg-gradient-to-b from-cloud-white to-bright-cloud-white'

  useEffect(() => {
    let stop = false

    void (async () => {
      for await (const message of messages) {
        if (stop) break

        setMessage(message)
        keepAliveMessage = message
      }
    })()

    return () => (stop = true)
  }, [messages])

  return (
    <TransitionGroup className='relative w-full'>
      <CSSTransition key={message} timeout={300} classNames='fade-slide-up'>
        <div
          className={classNames(
            'flex min-h-[3.5rem]  w-full items-center gap-x-2 rounded-2xl px-3 py-2',
            background
          )}>
          {message.length > 0 ? (
            <>
              <div className='p-2'>
                <div className='size-4'>
                  <ShoppingCartIcon />
                </div>
              </div>
              <span className='text-left text-xs'>{message}</span>
            </>
          ) : (
            <h6 className='w-full whitespace-nowrap text-center text-xs lg:text-sm'>
              🫧 3M+ Worldwide have made the switch 🫧
            </h6>
          )}
        </div>
      </CSSTransition>
    </TransitionGroup>
  )
}
